export const sistemaLabel = (string: string) => {
	return string.split(".")[1] || string;
};
